/* This file was automatically generated - please modify the template not this file! */

import { All } from "./All";
import { Detail } from "./Detail";
import { Edit } from "./Edit";
import { Create } from "./Create";

export const componentRoutes = [
    { route: "/create", component: Create },
    { route: "/:adminUserId/edit", component: Edit },
    { route: "/:adminUserId", component: Detail },
    { route: "/", component: All }
];
